export type OverrideAction =
	| "addQty"
	| "replaceQty"
	| "reset"
	| "setToAchievable"
	| "setToDemand"
	| "subtractQty"
	| "undoOverride";

export interface OptimisticRow {
	achievableQuantity?: number | null;
	demandQuantity: number;
	orderQuantity: number;
	previousOrderQuantity?: number | null;
}

const applyOptimisticOverride = (row: OptimisticRow, action: OverrideAction, quantity?: number): void => {
	switch (action) {
		case "addQty":
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity += quantity ?? 0;
			break;
		case "subtractQty":
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity = Math.max(0, row.orderQuantity - (quantity ?? 0));
			break;
		case "replaceQty":
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity = quantity ?? 0;
			break;
		case "setToDemand":
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity = row.demandQuantity;
			break;
		case "setToAchievable":
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity = row.achievableQuantity ?? row.orderQuantity;
			break;
		case "reset":
			if (row.achievableQuantity == null) break;
			row.previousOrderQuantity = row.orderQuantity;
			row.orderQuantity = row.achievableQuantity;
			break;
		case "undoOverride":
			if (row.previousOrderQuantity != null) {
				row.orderQuantity = row.previousOrderQuantity;
				row.previousOrderQuantity = undefined;
			}
			break;
	}
};

export default applyOptimisticOverride;
